export const FilterName = {
  CUST_OWNER: "custOwner",
  DATE_RANGE: "dateRange",
  FLOOR: "floor",
  INDUCT_AREA: "inductArea",
  OPEN_WORK_STATUS: "openWorkStatus",
  ORDER_TYPE: "orderType",
  ROTATION: "rotation",
  SEGMENT: "segment",
  TASK_TYPE: "taskType",
  UNIT_OF_MEASURE: "unitOfMeasure",
  WORK_STATUS: "workStatus",
  WORK_AREA_GROUPING: "workAreaGrouping",
  ZONE: "zone",
  TIMEFRAME: "timeFrame",
};

export const DashboardQueryParam = {
  CUSTOWNER: "custowner",
  FLOOR: "floor",
  MEASURE: "measure",
  GROUPBY: "groupby",
  ROTATION: "rotation",
  SEGMENT: "segment",
  TASKTYPE: "tasktype",
  ZONE: "zone",
  INDUCT_AREA: "inductArea",
  OPEN_WORK_STATUS: "openWorkStatus",
  TIMEFRAME: "timeFrame",
};

export const FormattedFilterName = {};
FormattedFilterName[DashboardQueryParam.CUSTOWNER] = "Cust Owner";
FormattedFilterName[DashboardQueryParam.FLOOR] = "Floor";
FormattedFilterName[DashboardQueryParam.MEASURE] = "Unit of Measure";
FormattedFilterName[DashboardQueryParam.GROUPBY] = "Grouping";
FormattedFilterName[DashboardQueryParam.ROTATION] = "Rotation";
FormattedFilterName[DashboardQueryParam.SEGMENT] = "Segment";
FormattedFilterName[DashboardQueryParam.TASKTYPE] = "Task Type";
FormattedFilterName[DashboardQueryParam.ZONE] = "Zone";
FormattedFilterName[DashboardQueryParam.INDUCT_AREA] = "Induct Area";
FormattedFilterName[DashboardQueryParam.OPEN_WORK_STATUS] = "Open Work Status";
FormattedFilterName[DashboardQueryParam.TIMEFRAME] = "Time Frame";

export const FilterType = {
  SINGLE: "singleSelect",
  MULTIPLE: "multipleSelect",
  DATE_RANGE: "dateRangePicker",
  DATE_TIME_RANGE: "dateTimeRangePicker",
  TIME_RANGE: "timeRangePicker",
  TEXT_FIELD: "textField",
  PERIOD_PICKER: "periodPicker",
  MONTH_PICKER: "monthPicker",
};

export const FilterDateRange = {
  LAST_1H: "last1h",
  LAST_6H: "last6h",
  TODAY: "today",
  LAST_7: "last7",
  MONTH_3: "month3",
  MONTH_1: "month1",
  YEAR_2: "year2",
};

export const FilterValue = {
  ALL: "ALL",
};

export const unitOfMeasurementOptions = [
  { value: "Lines", label: "Lines" },
  { value: "Units", label: "Units" },
];

export const taskTypeOptions = [
  { value: "PICK", label: "PICK" },
  { value: "PUT", label: "PUT" },
];

export const timeframeOptions = [
  { value: "Current Day", label: "Current Day" },
  { value: "Last Hour", label: "Last Hour" },
];

// Rotation options for URL encoding (format matches server data without degree symbols)
export const rotationOptions = [
  {
    value: " 0",
    label: "0",
  },
  {
    value: " 90",
    label: "90",
  },
  {
    value: "180",
    label: "180",
  },
  {
    value: "270",
    label: "270",
  },
];
